module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iSWNvbnMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzM0MzQzNDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPm1haWxBcnRib2FyZCAxPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yNCwwQTI0LDI0LDAsMSwwLDM3LjU3LDQzLjgyYTIsMiwwLDAsMC0yLjI2LTMuM0EyMCwyMCwwLDEsMSw0NCwyNHYxLjkxYTQuNyw0LjcsMCwxLDEtOS4zOSwwVjI0YTEwLjYzLDEwLjYzLDAsMSwwLTIuNDgsNi44MUE4LjY5LDguNjksMCwwLDAsNDgsMjUuOTFWMjRBMjQsMjQsMCwwLDAsMjQsMFptMCwzMC42MUE2LjYxLDYuNjEsMCwxLDEsMzAuNjEsMjQsNi42Miw2LjYyLDAsMCwxLDI0LDMwLjYxWiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-mail.svg
// module id = 569
// module chunks = 1